import "./MarketingHighlights.css";

function MarketingHighlights() {
  return (
    <>
      <section className="section intro">
        <p className="section-eyebrow">Training Advantage</p>
        <h2>Learning programs built for real workplace performance</h2>
        <p>
          Trainosys courses are designed for professionals and organizations
          that need practical skills, structured learning, hands-on exercises,
          and clear training outcomes.
        </p>
      </section>

      <section className="trust-grid">
        <article>
          <h3>Practical Skills</h3>
          <p>
            Courses focus on real tools, workflows, demonstrations, and
            workplace-ready exercises.
          </p>
        </article>
        <article>
          <h3>Business Impact</h3>
          <p>
            Training helps teams reduce skill gaps, improve execution, and
            support operational goals.
          </p>
        </article>
        <article>
          <h3>Flexible Delivery</h3>
          <p>
            Programs can be delivered onsite, online, hybrid, public, or
            customized for corporate teams.
          </p>
        </article>
      </section>
    </>
  );
}

export default MarketingHighlights;
